import { combineReducers } from 'redux';

const initialState = {
  home: {
    info: null,
  },

  refers: {
    loadedAll: false,
    loadStatus: 0,
    list: null,
    info: null,
  },
};

function homeReducer(state = initialState.home, action) {
  switch (action.type) {
    case 'LOAD_REPORT_COMPLETION': {
      const { data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        info: {
          teamMoneyToday: data.performance,
          moneyToday: data.performanceDirect,
          ordersToday: data.orderNum,
          moneyMonth: data.monthlyPerformance,
          refersMonth: data.newReferralNum,
          teamPeopleToday: data.newTeamNum,
          communityTotal: data.communityNum,
          teamPeopleTotal: data.teamNum,
          customersTotal: data.customerNum,
          kinshipTotal: data.kinshipNum,
          wallet: data.walletVo,
        },
      };
    }

    default:
      return state;
  }
}

function refersReducer(state = initialState.refers, action) {
  switch (action.type) {
    case 'LOAD_REFERS_COMPLETION': {
      const { data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        info: {
          directTotal: data.report.recommendAllDirect,
          nondirectTotal: data.report.recommendAllIndirect,
        },
      };
    }

    case 'LOAD_REFERS_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_REFERS_LIST_COMPLETION': {
      const { list, range, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        loadedAll: list.length < range.length,
        list: state.list
          ? state.list.slice(0, range.location).concat(list)
          : list,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  home: homeReducer,
  refers: refersReducer,
});
